import { Injectable } from '@angular/core';
import { NotifierOptions } from 'angular-notifier';
import { environment } from 'src/environments/environment';
export const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 1000
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};
@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public logoPath = "assets/images/logo.svg";
  public userIconPath = "assets/images/user.png";
  public notificationIconPath = "assets/images/notification.png";
  // public baseUrl = "http://localhost:52360";
  //https://vserver.co.in/regLakeStaging
  public pageLength = 50;
  public baseUrl = environment.baseURL; 
  public url= environment.baseUrl; 

  constructor() { }
}
